import { render, staticRenderFns } from "./KnowledgeBaseDropzone.vue?vue&type=template&id=4925d779&"
import script from "./KnowledgeBaseDropzone.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4925d779')) {
      api.createRecord('4925d779', component.options)
    } else {
      api.reload('4925d779', component.options)
    }
    module.hot.accept("./KnowledgeBaseDropzone.vue?vue&type=template&id=4925d779&", function () {
      api.rerender('4925d779', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/knowledgeBase/KnowledgeBaseDropzone.vue"
export default component.exports